import { Alert, AlertTitle, Stack, Typography } from '@mui/material';
import { DATE_FORMATS } from '../../../utils/Application_Constants';
import { currencyFormatter } from '../../../utils/helpers';
import { formatUtcDate } from '../../../utils/formatDate';
import {
    PROCESSED_TIMESHEET_ENTRY_INVOICE_STATUS_ENUM,
    PROCESSED_TIMESHEET_INVOICE_STATUS_ENUM,
} from '../../Configurations/processedTimesheetsConfig';

const getUnInvoicedWorkDates = (entries = []) => {
    const sortedDates = entries
        .filter(
            (entry) =>
                entry.invoiceStatus === PROCESSED_TIMESHEET_ENTRY_INVOICE_STATUS_ENUM.NotInvoiced
        )
        .map((entry) => entry.date)
        .sort((a, b) => new Date(a) - new Date(b));

    // Set preserves insertion order, so chronological order is kept after formatting
    return [...new Set(sortedDates.map((date) => formatUtcDate(date, DATE_FORMATS.SHORT_DATE)))];
};

export default function PartialInvoiceBanner({
    invoiceStatus,
    unInvoicedTotalToBill,
    processedTimesheetEntries = [],
}) {
    if (invoiceStatus !== PROCESSED_TIMESHEET_INVOICE_STATUS_ENUM.Partial) {
        return null;
    }

    const unInvoicedWorkDates = getUnInvoicedWorkDates(processedTimesheetEntries);

    return (
        <Alert severity="warning" data-testid="partial-invoice-banner">
            <AlertTitle>Partially invoiced</AlertTitle>
            <Stack gap={0.5}>
                <Typography variant="body2">
                    Some processed timesheet details have already been invoiced. Additional work
                    days remain available for future invoicing.
                </Typography>
                {unInvoicedTotalToBill != null && (
                    <Typography variant="body2">
                        Remaining billable amount: {currencyFormatter(unInvoicedTotalToBill)}
                    </Typography>
                )}
                {unInvoicedWorkDates.length > 0 && (
                    <Typography variant="body2">
                        Remaining work dates: {unInvoicedWorkDates.join(', ')}
                    </Typography>
                )}
            </Stack>
        </Alert>
    );
}
